import { render, staticRenderFns } from "./Growth.vue?vue&type=template&id=7735f8a1&scoped=true&"
import script from "./Growth.vue?vue&type=script&lang=js&"
export * from "./Growth.vue?vue&type=script&lang=js&"
import style0 from "./Growth.vue?vue&type=style&index=0&id=7735f8a1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7735f8a1",
  null
  
)

export default component.exports